import NoData from '@/components/tools/noData.vue'
export default {
  install() {
    Vue.component('NoData',NoData)
  }
}


// WEBPACK FOOTER //
// ./src/globalComponents.js